import React, { Component } from 'react'
import styled from 'styled-components'
import { connect } from 'react-redux'
import ConnectedRoomOptionTile from '../components/RoomOptionTile'
import Heading from '../components/Heading'
import PlayButtonConnected from '../components/PlayButton'

import RoomLivingImage from '../assets/images/room--living.png'
import RoomBathImage from '../assets/images/room--bath.png'
import RoomBedImage from '../assets/images/room--bed.png'
import RoomGarageImage from '../assets/images/room--garage.png'
import RoomKitchenImage from '../assets/images/room--kitchen.png'
import RoomLaundryImage from '../assets/images/room--laundry.png'
import RoomCityImage from '../assets/images/room--city.png'

import { media } from '../theme'

const Container = styled.div`
  margin-bottom: 4rem;
  position: relative;
  height: 100%;
  width: 100%;
`
// Desktop
const DesktopContainer = styled.div`
  height: 100%;
  display: none;
  ${media.greaterThan('medium')`
    display: block;
  `};
  padding-bottom: 40px;
`

const DesktopContent = styled.div`
  align-items: center;
  display: flex;
  flex-shrink: 0;
  justify-content: center;
  margin: 0 -${(p) => p.theme.spacing(7)};
  padding: 10px 0 40px 0;
  height: 12.5rem;
`

// Mobile
const MobileContainer = styled.div`
  align-items: center;
  flex-direction: column;
  justify-content: center;
  margin: 0 -${(p) => p.theme.spacing(6.5)};
  padding-bottom: ${(p) => p.theme.spacing(3.75)};
  transform: ${(p) => (p.context === 'modal' ? 'translateY(3%)' : 'none')};
  display: flex;
  ${media.greaterThan('medium')`
      display: ${(p) => (p.context === 'modal' ? 'flex' : 'none')}; 
  `};
`

const MobileRoomName = styled(Heading)`
  margin-top: ${(p) => p.theme.spacing(0)};
`

const TopContent = styled.div`
  width: 33.33%;
  display: flex;
  height: 100%;
`

const MiddleContent = styled.div`
  width: 50%;
  display: flex;
  margin-bottom: -23px;
  margin-top: -23px;
  height: 100%;
`

const BottomContent = styled.div`
  width: 33.33%;
  display: flex;
  height: 100%;
`

const DesktopSelectedRoom = styled.div`
  display: flex;
  justify-content: center;
  margin: -20px 0 20px 0;
  align-items: flex-start;
`

export const DesktopTileGroup = ({ gameFinished, selectedRoom }) => {
  return (
    <DesktopContainer>
      <Heading fullWidth={true} large={true} level={4}>
        {gameFinished ? 'Choose a room to play again' : 'Choose a room'}
      </Heading>

      <DesktopContent>
        <ConnectedRoomOptionTile
          viewport="desktop"
          img={RoomLivingImage}
          roomId="living-room"
          url="/living-room"
        />
        <ConnectedRoomOptionTile
          viewport="desktop"
          img={RoomKitchenImage}
          roomId="kitchen"
          url="/kitchen"
        />
        <ConnectedRoomOptionTile
          viewport="desktop"
          img={RoomBedImage}
          roomId="bedroom"
          url="/bedroom"
        />
        <ConnectedRoomOptionTile
          viewport="desktop"
          img={RoomBathImage}
          roomId="bathroom"
          url="/bathroom"
        />
        <ConnectedRoomOptionTile
          viewport="desktop"
          img={RoomLaundryImage}
          roomId="laundry-room"
          url="/laundry-room"
        />
        <ConnectedRoomOptionTile
          viewport="desktop"
          img={RoomGarageImage}
          roomId="garage"
          url="/garage"
        />
        <ConnectedRoomOptionTile
          viewport="desktop"
          img={RoomCityImage}
          roomId="city"
          url="/city"
        />
      </DesktopContent>

      <DesktopSelectedRoom>
        <Heading level={3}>{selectedRoom ? selectedRoom : ''}</Heading>
      </DesktopSelectedRoom>
    </DesktopContainer>
  )
}

export const MobileTilesGroup = ({ context, gameFinished, selectedRoom }) => {
  return (
    <MobileContainer context={context}>
      <Heading
        fullWidth={true}
        large={true}
        level={4}
        hide={context === 'modal'}
      >
        {gameFinished ? 'Choose a level to play again' : 'Choose a level'}
      </Heading>

      <TopContent>
        <ConnectedRoomOptionTile
          viewport="mobile"
          img={RoomLivingImage}
          roomId="living-room"
          url="/living-room"
        />
        <ConnectedRoomOptionTile
          viewport="mobile"
          img={RoomKitchenImage}
          roomId="kitchen"
          url="/kitchen"
        />
      </TopContent>

      <MiddleContent>
        <ConnectedRoomOptionTile
          viewport="mobile"
          img={RoomBedImage}
          roomId="bedroom"
          url="/bedroom"
        />

        <ConnectedRoomOptionTile
          viewport="mobile"
          img={RoomCityImage}
          roomId="city"
          url="/city"
        />

        <ConnectedRoomOptionTile
          viewport="mobile"
          img={RoomBathImage}
          roomId="bathroom"
          url="/bathroom"
        />
      </MiddleContent>

      <BottomContent>
        <ConnectedRoomOptionTile
          viewport="mobile"
          img={RoomGarageImage}
          roomId="garage"
          url="/garage"
        />

        <ConnectedRoomOptionTile
          viewport="mobile"
          img={RoomLaundryImage}
          roomId="laundry-room"
          url="/laundry-room"
        />
      </BottomContent>

      <MobileRoomName level={3} last={true}>
        {selectedRoom ? selectedRoom : 'Select'}
      </MobileRoomName>
    </MobileContainer>
  )
}

class LevelChooser extends Component {
  constructor(props) {
    super(props)
    this.handleClick = this.handleClick.bind(this)
  }

  handleClick(e) {
    const buttonUrl = this.props.startButtonUrl
    if (buttonUrl === null) {
      e.preventDefault()
      alert('please select level')
    }
  }

  render() {
    const { selectedRoom, isOver18 } = this.props
    const selectedRoomTrimmed = selectedRoom.split('-').join(' ')

    return (
      <Container>
        <DesktopTileGroup
          gameFinished={this.props.gameFinished}
          selectedRoom={selectedRoomTrimmed}
          isOver18={isOver18}
        />
        <MobileTilesGroup
          gameFinished={this.props.gameFinished}
          selectedRoom={selectedRoomTrimmed}
          isOver18={isOver18}
        />

        <PlayButtonConnected />
      </Container>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    selectedRoom: state.gameProgress.selectedRoom,
    isOver18: state.player.isOver18,
  }
}

const LevelChooserConnected = connect(mapStateToProps, null)(LevelChooser)
export default LevelChooserConnected



// WEBPACK FOOTER //
// ./src/components/LevelChooser.js